<template>
<div>
    <b-form-group :label="$t('users.available_groups')" v-if="$UIPrivilege('system', 'users', 'available_groups')">
        <b-form-checkbox-group name="users-available-groups" v-model="selectedUserGroups">
            <div v-for="group in allUserGroups" :key="'user-group-'+ group.id">
                <b-form-checkbox :id="'group-'+ group.id" :value="group.id" />
                <label :for="'group-'+ group.id">{{ group.description }}</label>
            </div>
        </b-form-checkbox-group>
    </b-form-group>
</div>
</template>

<script>
import userDataHandler from '@/store/system/userDataHandler';

export default {
    props: {
        value: {
            default: () => []
        }
    },
    computed: {
        selectedUserGroups: {
            get: function() {
                return this.value.map(group => group.id);
            },
            set: function(newIds) {
                this.$emit('input', this.allUserGroups.filter(group => newIds.includes(group.id)));
            }
        },
        allUserGroups() {
            return this.$store.state.userDataHandler.userGroups.list;
        }
    },
    beforeCreate() {
        if (!this.$store.state.userDataHandler) {
            this.$store.registerModule("userDataHandler", userDataHandler);
        }
        this.$store.dispatch('userDataHandler/getUserGroups');
    }
}
</script>
